import React from 'react';
import PropTypes from 'prop-types';
import { scrollToElement } from '@lib/scroller';

const AnchorLink = ({ anchorId, linkText }) => {
  const scrollToAnchor = (event) => {
    event.preventDefault();
    scrollToElement(document.getElementById(anchorId));
  };

  return (
    <a className="ch-btn--link" href={'#' + anchorId} onClick={scrollToAnchor}>
      {linkText}
    </a>
  );
};

AnchorLink.propTypes = {
  anchorId: PropTypes.string,
  linkText: PropTypes.string,
};

export default AnchorLink;
